<template>
    <div class="pager-wrap" v-if="shouldPaginate">
        <div class="pager primary">
            <div class="pager-item" v-if="page > 1" @click.prevent="page--">
                <a href="#" aria-lable="Next" rel="prev"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a>
            </div>
            <div class="pager-item" v-if="page > 1" :disabled="!prevUrl" @click.prevent="page--"><p v-text="page-1"></p></div>

            <div class="pager-item active"><p v-text="page"></p></div>

            <div class="pager-item" v-if="page < lastPage - 1" @click.prevent="page++"><p v-text="page+1"></p></div>

            <div class="pager-item" v-if="page < lastPage - 1"><p>...</p></div>

            <div class="pager-item" v-if="page < lastPage">
                <p v-text="lastPage" @click.prevent="page = lastPage"></p>
            </div>

            <div class="pager-item" v-show="page < lastPage" :disabled="!nextUrl" @click.prevent="page++">
                <a href="#" aria-lable="Next" rel="next"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['dataSet'],

        data() {
            return {
                page: 1,
                prevUrl: false,
                nextUrl: false,
                lastPage: false,
            }
        },

        watch: {
            dataSet() {
                this.page = this.dataSet.current_page;
                this.prevUrl = this.dataSet.prev_page_url;
                this.nextUrl = this.dataSet.next_page_url;
                this.lastPage = this.dataSet.last_page;

            },

            page() {
                this.broadcast().updateUrl();
            }
        },

        computed: {
            shouldPaginate() {
                return !! this.prevUrl || !! this.nextUrl;
            }
        },

        methods: {
            broadcast() {
                return this.$emit('changed', this.page);
            },
            updateUrl() {
                history.pushState(null, null, '?page=' + this.page);
            }
        }
    }

</script>